import { memo } from 'react'
import { LinkTypeSchema } from 'cms/schemaTypes/generalSchemas/linkType'
import { PortableText, PortableTextProps } from 'next-sanity'

import {
  CenterDecorator,
  ColorDecorator,
  formatText,
  LeftDecorator,
  LinkDecorator,
  renderAlignedChildren,
  RichTextAlignmentValue,
  RightDecorator,
  StyledStrong
} from './shared'

import styles from './RichTextLite.module.scss'

const RichTextLite: React.NamedExoticComponent<PortableTextProps> = memo(
  function RichTextLiteRenderer({
    components: _,
    ...props
  }: PortableTextProps): React.JSX.Element {
    return (
      <PortableText
        components={{
          marks: {
            alignment: ({ children, value }) =>
              renderAlignedChildren(
                children,
                value as RichTextAlignmentValue | undefined
              ),
            left: ({ children }) => LeftDecorator({ children }),
            right: ({ children }) => RightDecorator({ children }),
            center: ({ children }) => CenterDecorator({ children }),
            color: ({ children, value }) =>
              ColorDecorator({
                children,
                value: value as {
                  color?: { hex?: string }
                  colorReference?: { color?: string }
                }
              }),
            link: ({ children, value }) =>
              LinkDecorator({
                children,
                value: value as { link?: LinkTypeSchema }
              }),
            strong: ({ children }) => <StyledStrong>{children}</StyledStrong>,
            em: ({ children }) => (
              <em className={styles.emphasis}>{children}</em>
            ),
            underline: ({ children }) => (
              <span className={styles.underline}>{children}</span>
            ),
            'strike-through': ({ children }) => (
              <span className={styles.strikeThrough}>{children}</span>
            )
          },
          block: ({ children }) => (
            <span className={styles.block}>{formatText(children)}</span>
          )
        }}
        {...props}
      />
    )
  }
)

export default RichTextLite
